// src/index.js
import "./index.css";
// Central Swiper CSS imports
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/free-mode";
import "swiper/css/grid";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import App from "./App";
import { BrowserRouter } from "react-router-dom";


const store = configureStore({ reducer: rootReducer, devTools: true });

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Remove the FOUC overlay
const foucOverlay = document.getElementById("fouc-overlay");
if (foucOverlay) {
  foucOverlay.remove();
}

root.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
